import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useGetVideosQuery } from "../../redux/features/video/videoApi";

export default function PublicRoute({ children }) {
    const {role} = useAuth() || {};
    const {data: videos,isLoading, isError } = useGetVideosQuery();
    const videoPath = localStorage.getItem("videoPath");

    if(role === "student"){
        if(videoPath){
            return  <Navigate to={`/courses/${videoPath}`}/>
        }
        else if(!isLoading && !isError && videos?.length){
    
            return <Navigate to={`/courses/${videos[0].id}`}/>
        }
    }
    else if(role === "admin"){
        return <Navigate to={`/admin/dashboard`}/>
    }else{
       return children
    }
}